import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  input {
    min-width: 100%;
    width: 100% !important;
  }
`;
